import CertCard from "./CertCard.js";
import ethicalHacking from "../assets/certs/ethicalHacking.png";
import fyndey from "../assets/certs/fyndey.png";
import goc from "../assets/certs/goc.png";
import Gs from "../assets/certs/GS-evp.png";
import gssoc from "../assets/certs/gssoc.png";
import java from "../assets/certs/java.png";
import jpmc from "../assets/certs/jpmc.png";
import peatix from "../assets/certs/peatix.png";
import php from "../assets/certs/php.png";
import swoc from "../assets/certs/swoc.png";
import techrity from "../assets/certs/techrity.png";
import zuno from "../assets/certs/Zuno.png";
import Inspire from "../assets/certs/Inspire.jpg";
import gssocPA from "../assets/certs/gssocPA.png";
import udemyjs from "../assets/certs/udemyjs.jpg";
import merit from "../assets/certs/merit.jpg";
import bpit_da from "../assets/certs/bpit_da.png";
import { useEffect, useState } from "react";
import Slider from "react-slick";

export default function Certs() {
  const [slides, setSlides] = useState(3);
  const [showAllCards, setShowAllCards] = useState(false);

  const toggleCardsVisibility = () => {
    setShowAllCards(!showAllCards);
  };
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const width = screen.width;
    if (width < 500) {
      setSlides(1);
    }
  }, []);
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    slidesToShow: slides,
    slidesToScroll: 1,
  };
  return (
    <div id="certificates" className="mt-4 text-white">
      <div className="flex justify-between">
        <div>
          <h1 className="text-2xl font-bold">Certificates</h1>
          <p className="font-light text-gray-400">
            Here are some of my certificates
          </p>
        </div>
        <div>
          <button onClick={toggleCardsVisibility}>
            {showAllCards ? "Show Carousel" : "Show All"}
          </button>
        </div>
      </div>
      {showAllCards ? (
        <div className="grid grid-cols-1 md:grid-cols-3 justify-center mt-4 gap-5">
          <CertCard
            link={merit}
            name="Merit Certificate"
            img={merit}
            issued="Bhagwan Parshuram Institute of Technology"
          />
          <CertCard
            link={gssocPA}
            name="Project Admin-Certificate of Recognition"
            img={gssocPA}
            issued="GSSoC'23"
          />
          <CertCard
            link={bpit_da}
            name="Internship Completion Certificate"
            img={bpit_da}
            issued="Bhagwan Parshuram Institute of Technology"
          />
          <CertCard
            link={udemyjs}
            name="JavaScript - Basics to Advanced"
            img={udemyjs}
            issued="Udemy"
          />
          <CertCard
            link={fyndey}
            name="Internship Completion Certificate"
            img={fyndey}
            issued="Fyndey Solutions Pvt Ltd"
          />
          <CertCard
            link={jpmc}
            name="Software Engineering Virtual Experience"
            img={jpmc}
            issued="JP Morgan Chase & Co."
          />
          <CertCard
            link={Gs}
            name="Engineering Virtual Program"
            img={Gs}
            issued="Goldman Sachs"
          />
          <CertCard
            link={gssoc}
            name="Open Source Contribution Certificate"
            img={gssoc}
            issued="GSSoC'22"
          />
          <CertCard
            link={techrity}
            name="Finalist in Frontend Developement Track"
            img={techrity}
            issued="Techrity"
          />
          <CertCard link={goc} name="Game of Code'22" img={goc} issued="IEEE" />
          <CertCard
            link={zuno}
            name="Silver Winner"
            img={zuno}
            issued="Zuno Fellowship Program"
          />
          <CertCard
            link={java}
            name="Completion of Java Training"
            img={java}
            issued="Spoken Tutorial, IIT Bombay"
          />
          <CertCard
            link={peatix}
            name="Internship Completion Certificate"
            img={peatix}
            issued="Peatix IT Pvt Ltd"
          />
          <CertCard
            link={php}
            name="Completion of Php and MySQL Training"
            img={php}
            issued="Spoken Tutorial, IIT Bombay"
          />
          <CertCard
            link={swoc}
            name="Open Source Contribution Certificate"
            img={swoc}
            issued="Social Winter of Code"
          />
          <CertCard
            link={Inspire}
            name="Inspire Internship Program"
            img={Inspire}
            issued="University of Delhi"
          />
          <CertCard
            link={ethicalHacking}
            name="Ethical Hacking: SQL Injection"
            img={ethicalHacking}
            issued="Udemy"
          />
        </div>
      ) : (
        <div className="mt-4">
          <Slider {...settings}>
            {/* Render the slider with cards */}
            <CertCard
              link={merit}
              name="Merit Certificate"
              img={merit}
              issued="Bhagwan Parshuram Institute of Technology"
            />
            <CertCard
              link={gssocPA}
              name="Project Admin-Certificate of Recognition"
              img={gssocPA}
              issued="GSSoC'23"
            />
            <CertCard
              link={bpit_da}
              name="Internship Completion Certificate"
              img={bpit_da}
              issued="Bhagwan Parshuram Institute of Technology"
            />
            <CertCard
              link={udemyjs}
              name="JavaScript - Basics to Advanced"
              img={udemyjs}
              issued="Udemy"
            />
            <CertCard
              link={fyndey}
              name="Internship Completion Certificate"
              img={fyndey}
              issued="Fyndey Solutions Pvt Ltd"
            />
            <CertCard
              link={jpmc}
              name="Software Engineering Virtual Experience"
              img={jpmc}
              issued="JP Morgan Chase & Co."
            />
            <CertCard
              link={Gs}
              name="Engineering Virtual Program"
              img={Gs}
              issued="Goldman Sachs"
            />
            <CertCard
              link={gssoc}
              name="Open Source Contribution Certificate"
              img={gssoc}
              issued="GSSoC'22"
            />
            <CertCard
              link={techrity}
              name="Finalist in Frontend Developement Track"
              img={techrity}
              issued="Techrity"
            />
            <CertCard
              link={goc}
              name="Game of Code'22"
              img={goc}
              issued="IEEE"
            />
            <CertCard
              link={zuno}
              name="Silver Winner"
              img={zuno}
              issued="Zuno Fellowship Program"
            />
            <CertCard
              link={java}
              name="Completion of Java Training"
              img={java}
              issued="Spoken Tutorial, IIT Bombay"
            />
            <CertCard
              link={peatix}
              name="Internship Completion Certificate"
              img={peatix}
              issued="Peatix IT Pvt Ltd"
            />
            <CertCard
              link={php}
              name="Completion of Php and MySQL Training"
              img={php}
              issued="Spoken Tutorial, IIT Bombay"
            />
            <CertCard
              link={swoc}
              name="Open Source Contribution Certificate"
              img={swoc}
              issued="Social Winter of Code"
            />
            <CertCard
              link={Inspire}
              name="Inspire Internship Program"
              img={Inspire}
              issued="University of Delhi"
            />
            <CertCard
              link={ethicalHacking}
              name="Ethical Hacking: SQL Injection"
              img={ethicalHacking}
              issued="Udemy"
            />
          </Slider>
        </div>
      )}
      <div className="line"></div>
    </div>
  );
}
